<template>
  <div class="page noselect">
    <!--<div class="absBack"> -->
    <!--           <div onclick="window.history.back()"> -->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon> -->
    <!--            </div> -->
    <!--        </div> -->

    <v-container grid-list-md>
      <h2 class="text-center mt-7">Verwendung von Cookies</h2>
      <!--            <p>-->
      <!--                Ein Cookie ist ein kurzes Text-Snippet, das von einer von Ihnen besuchten Website an Ihren Browser-->
      <!--                gesendet wird. Es speichert Informationen zu Ihrem letzten Besuch, wie Ihre bevorzugte Sprache oder-->
      <!--                andere Einstellungen. So finden Sie sich auf der Website schneller zurecht und nutzen sie effektiver,-->
      <!--                wenn Sie sie das nächste Mal aufrufen. Cookies spielen eine wichtige Rolle. Ohne sie wäre das Surfen im-->
      <!--                Web oft frustrierend.-->
      <!--            </p>-->
      <!--            <p>THEURER speichert Ihre Daten DSGVO-konform auf Servern in Deutschland.-->
      <!--                Sie erhalten zu keinen Zeitpunk Werbeanrufe oder Werbung durch Dritte.-->
      <!--            </p>-->
      <!--            <div class="spacer-25"></div>-->
      <!--            <h3>Aktuelle Datenschutseinstellungen:</h3>-->
      <p>Hier findest Du eine Übersicht über alle verwendeten Cookies.
        Einige von ihnen sind notwendig, während uns andere dabei helfen, unsere Inhalte und Werbung
        entsprechend Deiner Interessen anzuzeigen. Nähere Informationen zur Datenverarbeitung findest du in
        unserer
        <router-link :to="{ name: 'Datenschutz' }">Datenschutzerklärung
        </router-link>
      </p>
      <p>
        Entsprechend denen von Ihnen festgelegten <a href="#" @click.passive="clickDsgvo">Datenschutzeinstellungen</a>
        geben wir Informationen zur Verwendung unserer Webseite an unsere Partner für soziale Medien,
        Werbung und Analysen weiter.
        Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen,
        die du im Rahmen Deiner Nutzung der jeweiligen Dienste gesammelt hast.
      </p>
      <!--            <p>-->
      <!--                Nutzen Sie den Button "Datenschutzeinstellungen", um Ihre-->
      <!--                Einwilligung zu den Cookies zu bearbeiten.-->
<!--      </p>-->

      <div class="spacer-25"></div>

      <v-expansion-panels
        :hover="true"
      >
        <v-expansion-panel
          key="1"
        >
          <v-expansion-panel-header><h4 class="text-none dialogText">Notwendige Cookies</h4></v-expansion-panel-header>
          <v-expansion-panel-content>
            <!--                        <div class="cookies">-->
            <!--                            <table class="maxw cookieTable">-->
            <!--                                <tr>-->
            <!--                                    <td>Name</td>-->
            <!--                                    <td>Google reCAPTCHA</td>-->
            <!--                                </tr>-->
            <!--                                <tr>-->
            <!--                                    <td>Anbieter</td>-->
            <!--                                    <td>Alphabet Inc.</td>-->
            <!--                                </tr>-->
            <!--                                <tr>-->
            <!--                                    <td>Zweck</td>-->
            <!--                                    <td>Dies ist ein Dienst, der prüft, ob auf einer Seite eingegebene Daten von einem-->
            <!--                                        Menschen oder von einem automatisierten Programm eingegeben wurden.-->
            <!--                                    </td>-->
            <!--                                </tr>-->
            <!--                                <tr>-->
            <!--                                    <td>Details</td>-->
            <!--                                    <td><a target="_blank" href="https://policies.google.com/privacy?hl=de">https://policies.google.com/privacy?hl=de</a>-->
            <!--                                    </td>-->
            <!--                                </tr>-->
            <!--                            </table>-->
            <!--                        </div>-->

            <div class="cookies">
              <table class="maxw cookieTable">
                <tr>
                  <td>Name</td>
                  <td>Payone Analyse-Cookies</td>
                </tr>
                <tr>
                  <td>Anbieter</td>
                  <td>PAYONE GmbH</td>
                </tr>
                <tr>
                  <td>Zweck</td>
                  <td>Unterstützung der sicheren Durchführung von Online-Zahlungen, Betrugserkennung und Verbesserung des Zahlungsprozesses
                  </td>
                </tr>
                <tr>
                  <td>Details</td>
                  <td><a target="_blank"
                         href="https://www.payone.com/DE-de/datenschutz">
                    https://www.payone.com/DE-de/datenschutz
                  </a>
                  </td>
                </tr>
              </table>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-expansion-panels>

      <div class="spacer-15"></div>


      <v-expansion-panels
        :hover="true"
      >
        <v-expansion-panel
          key="1"
        >
          <v-expansion-panel-header><h4 class="text-none dialogText">Statistiken</h4></v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="cookies">
              <table class="maxw cookieTable">
                <tr>
                  <td>Name</td>
                  <td>Google Analytics</td>
                </tr>
                <tr>
                  <td>Anbieter</td>
                  <td>Google LLC</td>
                </tr>
                <tr>
                  <td>Zweck</td>
                  <td>Cookie von Google zur Analyse der Webseitenverwendung. Erzeugt statistische Daten
                    darüber, wie der Besucher die Webseite nutzt.
                  </td>
                </tr>
                <tr>
                  <td>Details</td>
                  <td><a target="_blank" href="https://policies.google.com/privacy?hl=de">https://policies.google.com/privacy?hl=de</a>
                  </td>
                </tr>
              </table>
            </div>

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="spacer-15"></div>


      <!--            <v-expansion-panels-->
      <!--                    :hover="true"-->
      <!--            >-->
      <!--                <v-expansion-panel-->
      <!--                        key="1"-->
      <!--                >-->
      <!--                    <v-expansion-panel-header><h2 class="text-none">Facebook</h2></v-expansion-panel-header>-->
      <!--                    <v-expansion-panel-content>-->
      <!--                        <div class="cookies">-->
      <!--                            <table class="maxw cookieTable">-->
      <!--                                <tr>-->
      <!--                                    <td>Name</td>-->
      <!--                                    <td>Facebook Pixel</td>-->
      <!--                                </tr>-->
      <!--                                <tr>-->
      <!--                                    <td>Anbieter</td>-->
      <!--                                    <td>Facebook Inc.</td>-->
      <!--                                </tr>-->
      <!--                                <tr>-->
      <!--                                    <td>Zweck</td>-->
      <!--                                    <td>Conversion-Tracking Analyse zur Verbesserung von zielgerichteten-->
      <!--                                        Marketing-Kampagnen.-->
      <!--                                    </td>-->
      <!--                                </tr>-->
      <!--                                <tr>-->
      <!--                                    <td>Details</td>-->
      <!--                                    <td><a target="_blank" href="https://www.facebook.com/policies/cookies/">https://www.facebook.com/policies/cookies/</a>-->
      <!--                                    </td>-->
      <!--                                </tr>-->
      <!--                            </table>-->
      <!--                        </div>-->

      <!--                    </v-expansion-panel-content>-->
      <!--                </v-expansion-panel>-->
      <!--            </v-expansion-panels>-->

      <div class="spacer-25"></div>

      <div class="spacer-15"></div>

      <div class="text-center">
        <v-btn class="okBtn btn-df text-none" rounded @click.native.passive.stop="clickDsgvo">
          Datenschutzeinstellungen
        </v-btn>
      </div>

      <div class="spacer-25"></div>
      <div class="spacer-25"></div>
      <div class="text-center">
        <router-link :to="{ name: 'Datenschutz' }">Datenschutzerklärung</router-link>
      </div>

    </v-container>
  </div>
</template>

<script>
import {ebus} from '../vendor/ebus';

export default {
  name: "Cookies",
  destroyed() {
    ebus.$emit('checkDsgvo');
  },
  methods: {
    clickDsgvo() {
      ebus.$emit('checkDsgvo', true);
      return false;
    }
  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

//.page ::v-deep .v-expansion-panel-content {
//        background-color: $color-secondary;
//    }

.cookies {
  background-color: $color-gray;
  margin-top: 15px;
  margin-bottom: 10px;
  padding: 15px;
  color: black;
}

.cookieTable {

  td {
    border-bottom: 1px solid #737373;
    padding: 5px;
  }

  td {
    &:first-child {
      width: 100px;
      //font-weight: 700;
    }

    &:last-child {
      font-size: 0.8em;
    }
  }

  tr {
    &:last-child {
      td {
        border: none;
      }
    }
  }
}
</style>
